<rappider-title-toolbar [mainTitle]="titleConfig"
                        [options]="breadcrumbs"></rappider-title-toolbar>

<section>
  <!-- a form to execute an api call, we only need a text area and a button under it, build it with ng zorro -->
  <div>
    <textarea nz-input
              [(ngModel)]="apiCallTestInput"
              [nzAutosize]="{ minRows: 3, maxRows: 10 }"
              [placeholder]="'Enter your prompt input here'">
</textarea>
    <button nz-button
            [nzLoading]="isAITestInProgress"
            (click)="updateFunctionAndExecute()"
            [disabled]="!apiCallTestInput">
      Execute API Call
    </button>
  </div>


</section>
